"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _Bubble = _interopRequireDefault(require("../../Bubble"));
var _QuestionCircle = _interopRequireDefault(require("../../../icons-react/QuestionCircle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CheckoutExtraOption = function CheckoutExtraOption(props) {
  var onChange = props.onChange,
    _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    _props$touched = props.touched,
    touched = _props$touched === void 0 ? false : _props$touched,
    option = props.option,
    tooltip = props.tooltip,
    className = props.className;
  var price = option.price,
    description = option.description,
    variant = option.variant;
  var changeHandler = function changeHandler() {
    return onChange(option, !checked);
  };
  var hasDescription = Boolean(description);
  return /*#__PURE__*/_react["default"].createElement(StyledCheckoutExtraOption, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(StyledCheckbox, {
    onChange: changeHandler,
    checked: checked,
    touched: touched
  }), /*#__PURE__*/_react["default"].createElement(StyledName, {
    checked: checked,
    touched: touched
  }, variant, tooltip ? /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    text: tooltip
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, null)) : null), /*#__PURE__*/_react["default"].createElement(StyledPrice, {
    value: price,
    checked: checked,
    prefix: "+ "
  })), hasDescription ? /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description) : null);
};
var StyledCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "CheckoutExtraOption__StyledCheckbox",
  componentId: "sc-o524jh-0"
})(["", ""], function (_ref) {
  var checked = _ref.checked,
    touched = _ref.touched;
  return !checked && touched && "\n      & input:after {\n        border: 1px dashed #C2C5CC;\n      }\n    ";
});
var StyledCheckoutExtraOption = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraOption__StyledCheckoutExtraOption",
  componentId: "sc-o524jh-1"
})(["margin-top:8px;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraOption__Row",
  componentId: "sc-o524jh-2"
})(["display:flex;flex-direction:row;align-items:center;"]);
var StyledName = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraOption__StyledName",
  componentId: "sc-o524jh-3"
})(["display:flex;font-size:14px;line-height:16px;margin-left:6px;color:", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackBase;
}, function (_ref3) {
  var checked = _ref3.checked,
    touched = _ref3.touched;
  return !checked && touched && UncheckedText;
});
var CheckedPrice = (0, _styledComponents.css)(["background:", ";border-radius:10px;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.yellowBase;
});
var UncheckedText = (0, _styledComponents.css)(["color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyLight;
});
var StyledPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "CheckoutExtraOption__StyledPrice",
  componentId: "sc-o524jh-4"
})(["padding:0px 8px;margin-left:24px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;white-space:nowrap;color:", ";", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blackBase;
}, function (_ref7) {
  var checked = _ref7.checked;
  return checked ? CheckedPrice : UncheckedText;
});
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraOption__StyledDescription",
  componentId: "sc-o524jh-5"
})(["font-family:'ONYOneFont','Helvetica',sans-serif;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;margin-left:24px;margin-top:4px;color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyLight;
});
var StyledQuestionIcon = (0, _styledComponents["default"])(_QuestionCircle["default"]).withConfig({
  displayName: "CheckoutExtraOption__StyledQuestionIcon",
  componentId: "sc-o524jh-6"
})(["cursor:pointer;width:14px;height:14px;margin-left:4px;vertical-align:bottom;circle{stroke:#919499;}path{stroke:#919499;}"]);
var _default = exports["default"] = CheckoutExtraOption;